export const SET_BOOKING_QUERY_STRING_PARAMS = 'SET_BOOKING_QUERY_STRING_PARAMS' as const;
export const SET_BOOKING_ITEM = 'SET_BOOKING_ITEM' as const;
export const SET_ROOM_INFO = 'SET_ROOM_INFO' as const;
export const SET_USER_INFO = 'SET_USER_INFO' as const;
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO' as const;
export const SET_PRIVACY_POLICY = 'SET_PRIVACY_POLICY' as const;